import { Navigate, useSearchParams } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";

import { useSupabase } from "./SupabaseProvider";

/**
 * Public sign-in page. Single Google OAuth button. Reads `?next=<path>`
 * from the URL and round-trips it via `redirectTo` so the post-sign-in
 * landing matches the originally-requested deep link.
 *
 * If the user already has a session, immediately redirect to `next` (or
 * `/jobs`) — pressing Back from a deep page shouldn't re-prompt sign-in.
 */
export function SignIn() {
  const { client, session, loading } = useSupabase();
  const [params] = useSearchParams();
  const next = params.get("next") ?? "/jobs";

  if (loading) return null;
  if (session) return <Navigate to={next} replace />;

  const onSignIn = () => {
    const redirectTo = `${window.location.origin}/auth/callback?next=${encodeURIComponent(next)}`;
    void client.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo },
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-bg-card border border-border rounded p-10 space-y-8">
        <div className="space-y-3 text-center">
          <Logo width={140} className="mx-auto" />
          <p className="label-mono">Internal admin</p>
          <h1 className="font-display text-3xl text-text">Sign in</h1>
          <p className="text-sm text-text-muted">
            Restricted to <span className="font-mono">@prospect.solutions</span> accounts.
          </p>
        </div>
        <Button onClick={onSignIn} className="w-full" size="lg">
          Continue with Google
        </Button>
      </div>
    </div>
  );
}
